import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService, AppConfig } from './_services/app.layout.service';
import { ApiService } from './_services/api.service';
import { GlobalService } from './_services/global.service';
import { LanguageService } from './_services/language.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
    configIsLoaded: Promise<boolean> | undefined;
    constructor(
        private apiService: ApiService,
        private lang:LanguageService,
        public globalService : GlobalService,
        private primengConfig: PrimeNGConfig, 
        private layoutService: LayoutService) {
           
         }

    async ngOnInit(): Promise<void> {
         await this.lang.ensureTextsLoaded();
         this.lang.applyUiTranslations();
         if (this.globalService.getUser()) {
           void this.lang.loadDesTranslations();
         }
        this.primengConfig.ripple = true;
         //optional configuration with the default configuration
         const config: AppConfig = {
            ripple: false,                      //toggles ripple on and off
            inputStyle: 'outlined',             //default style for input elements
            menuMode: 'drawer',                 //layout mode of the menu, valid values are "static", "overlay", "slim", "horizontal", "reveal" and "drawer" 
            colorScheme: 'light',               //color scheme of the template, valid values are "light", "dim" and "dark"
            theme: 'blue',                    //default component theme for PrimeNG
            menuTheme: "colorScheme",           //theme of the menu, valid values are "colorScheme", "primaryColor" and "transparent"
            scale: 12                         //size of the body font size to scale the whole application
        };
        let conf:any=localStorage.getItem('appThemeConfig');
        conf=null;
        if(conf){
            this.layoutService.config.set(JSON.parse(conf));
            if(conf.theme!=config.theme){
                this.layoutService.changeTheme();
            }
            this.layoutService.changeTheme();
          
        } else {
            this.layoutService.config.set(config);
        }
        this.apiService.post("app/config",{}).subscribe(data2 => {
            this.globalService.configModules=data2.Result;
            this.configIsLoaded = Promise.resolve(true); 
        });
        if(window.location.href.toUpperCase().indexOf('DAGARD')>=0){
            this.globalService.societa='DAGARD';
        }
    }
}
